import { COLORS } from '@btime/constants'
import { generateContext } from '@btime/react-contexts'
import { pick } from 'ramda'
import { useFormState } from '@btime/react-hooks'
import React, { useEffect } from 'react'
import { getLocalStorageItem, setLocalStorageItem } from '../../../../utils/helpers/localStorage'
import STORAGE_CONSTANTS from '../../../../utils/constants/storage'

const { StateContext, ActionsContext, Provider } = generateContext()
export const usePdfOptionsForm = () => React.useContext(StateContext)
export const usePdfOptionsFormActions = () => React.useContext(ActionsContext)

export const useFontBase = () => usePdfOptionsForm().fontBase
export const useShouldHideImages = () => !usePdfOptionsForm().showImages
export const useShouldHideSign = () => !usePdfOptionsForm().showSign
export const useImagesSize = () => pick(['imagesHeight', 'imagesPerRow'], usePdfOptionsForm())
export const useShouldHideColors = () => !usePdfOptionsForm().hasColors
export const useShouldAdjustPageBreaks = () => usePdfOptionsForm().enableNoWrap

const loadSavedOptions = () => {
  return getLocalStorageItem(STORAGE_CONSTANTS.PDF_OPTIONS_STORAGE_KEY) || {}
}

const saveOptions = options => {
  setLocalStorageItem(STORAGE_CONSTANTS.PDF_OPTIONS_STORAGE_KEY, options)
}

const PdfOptionsFormHandler = ({ initialState, children }) => {
  initialState = initialState || {}
  const savedOptions = loadSavedOptions()

  const defaultOptions = {
    showImages: true,
    showSign: true,
    hasColors: true,
    imagesHeight: 0,
    imagesPerRow: 4,
    fontBase: 14,
    enableNoWrap: true,
    preview: true,
    fontBaseColor: COLORS.dark3,
    hideChildrenServiceOrders: true
  }

  const [form, handleChange, setForm] = useFormState({
    ...defaultOptions,
    ...savedOptions,
    hideChildrenServiceOrders: true,
    showChildrenActive: true,
    showChildrenQuestionnaire: true,
    showChildrenDestination: true,
    showChildrenCheckIn: true,
    showChildrenCheckOut: true,
    ...initialState
  })

  useEffect(() => {
    saveOptions(form)
  }, [form])

  const mergeChanges = value => {
    const newForm = { ...form, ...value }
    setForm(newForm)
  }

  return (
    <Provider
      state={form}
      actions={{
        handleChange,
        mergeChanges
      }}
    >
      {children}
    </Provider>
  )
}

export default PdfOptionsFormHandler
